module.exports = __webpack_public_path__ + "img/2.d53fd356.png";